import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, mergeProps as _mergeProps, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-title" };
const _hoisted_4 = { class: "form-menu" };
const _hoisted_5 = { class: "float-end" };
const _hoisted_6 = { class: "form-contents" };
const _hoisted_7 = { class: "row" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-12" };
const _hoisted_10 = { class: "clearfix" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-12 bottom10" };
const _hoisted_12 = { class: "invalid-feedback" };
const _hoisted_13 = { class: "clearfix" };
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_15 = { class: "invalid-feedback" };
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_17 = { class: "clearfix" };
const _hoisted_18 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_19 = { class: "col-xs-12 col-sm-12 col-md-6 bottom10" };
const _hoisted_20 = { class: "clearfix" };
const _hoisted_21 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_AlertComponent = _resolveComponent("AlertComponent");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_CollapsibleForm = _resolveComponent("CollapsibleForm");
    const _component_AlarmDefinitionsVue = _resolveComponent("AlarmDefinitionsVue");
    return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("h2", {
                    class: _normalizeClass({ 'red-text': _ctx.isAlarmTypeArchived })
                }, _toDisplayString(_ctx.pageTitle || 'Missing alarm type name...'), 3 /* TEXT, CLASS */)
            ]),
            _cache[9] || (_cache[9] = _createTextVNode()),
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                                _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Save", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _cache[7] || (_cache[7] = _createTextVNode()),
                    _createCommentVNode("<b-button type=\"button\" variant=\"danger\" @click=\"archive\" v-show=\"!isNewAlarmType && !isAlarmTypeArchived\">\r\n\t\t\t\t\t\t<i class=\"fa fa-trash\"></i><span class=\"hidden-xs\">&nbsp;Archive</span>\r\n\t\t\t\t\t</b-button>\r\n\t\t\t\t\t<b-button type=\"button\" variant=\"warning\" @click=\"restore\" v-show=\"!isNewAlarmType && isAlarmTypeArchived\">\r\n\t\t\t\t\t\t<i class=\"fa fa-refresh\"></i><span class=\"hidden-xs\">&nbsp;Restore</span>\r\n\t\t\t\t\t</b-button>"),
                    _cache[8] || (_cache[8] = _createTextVNode()),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.goBack
                    }, {
                        default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Close", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _cache[32] || (_cache[32] = _createTextVNode()),
        _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_AlertComponent, { msg: _ctx.msg }, null, 8 /* PROPS */, ["msg"])
                ]),
                _cache[30] || (_cache[30] = _createTextVNode()),
                _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_CollapsibleForm, null, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d;
                            return [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _cache[10] || (_cache[10] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tName *\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _cache[11] || (_cache[11] = _createTextVNode()),
                                        _createVNode(_component_b_form_input, _mergeProps(_ctx.nameVal, {
                                            name: "systemName",
                                            type: "text",
                                            maxlength: "150",
                                            modelValue: _ctx.alarmType.alarmTypeName,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.alarmType.alarmTypeName) = $event)),
                                            modelModifiers: { trim: true },
                                            class: { 'is-invalid': (_a = _ctx.errors) === null || _a === void 0 ? void 0 : _a.name }
                                        }), null, 16 /* FULL_PROPS */, ["modelValue", "class"]),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _withDirectives(_createElementVNode("div", _hoisted_12, "\r\n\t\t\t\t\t\t\t\t\t\t* Please enter a system name.\r\n\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, (_b = _ctx.errors) === null || _b === void 0 ? void 0 : _b.name]
                                        ])
                                    ])
                                ]),
                                _cache[28] || (_cache[28] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_13, [
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[14] || (_cache[14] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tScope *\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _cache[15] || (_cache[15] = _createTextVNode()),
                                        _createVNode(_component_multiselect, _mergeProps(_ctx.scopeVal, {
                                            name: "alarmScopeId",
                                            modelValue: _ctx.alarmScope,
                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.alarmScope) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.alarmScopes,
                                            showLabels: false,
                                            class: { 'is-invalid': (_c = _ctx.errors) === null || _c === void 0 ? void 0 : _c.scope }
                                        }), {
                                            noResult: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                                    _createTextVNode("No results found", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 16 /* FULL_PROPS */, ["modelValue", "placeholder", "options", "class"]),
                                        _cache[16] || (_cache[16] = _createTextVNode()),
                                        _withDirectives(_createElementVNode("div", _hoisted_15, "\r\n\t\t\t\t\t\t\t\t\t\t* Please select an alarm scope\r\n\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                            [_vShow, (_d = _ctx.errors) === null || _d === void 0 ? void 0 : _d.scope]
                                        ])
                                    ]),
                                    _cache[20] || (_cache[20] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_16, [
                                        _cache[18] || (_cache[18] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tMeasurement\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _cache[19] || (_cache[19] = _createTextVNode()),
                                        _createVNode(_component_multiselect, {
                                            name: "measurementTypeId",
                                            modelValue: _ctx.measurementType,
                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.measurementType) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.measurementTypes,
                                            showLabels: false
                                        }, {
                                            noResult: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                    _createTextVNode("No results found", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                    ])
                                ]),
                                _cache[29] || (_cache[29] = _createTextVNode()),
                                _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("div", _hoisted_18, [
                                        _cache[22] || (_cache[22] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tString Status\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _cache[23] || (_cache[23] = _createTextVNode()),
                                        _createVNode(_component_multiselect, {
                                            name: "stringStatusId",
                                            modelValue: _ctx.stringStatus,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.stringStatus) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.stringStates,
                                            showLabels: false
                                        }, {
                                            noResult: _withCtx(() => [...(_cache[21] || (_cache[21] = [
                                                    _createTextVNode("No results found", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                    ]),
                                    _cache[27] || (_cache[27] = _createTextVNode()),
                                    _createElementVNode("div", _hoisted_19, [
                                        _cache[25] || (_cache[25] = _createElementVNode("label", null, "\r\n\t\t\t\t\t\t\t\t\t\tLayout\r\n\t\t\t\t\t\t\t\t\t", -1 /* CACHED */)),
                                        _cache[26] || (_cache[26] = _createTextVNode()),
                                        _createVNode(_component_multiselect, {
                                            name: "limitLayoutId",
                                            modelValue: _ctx.limitLayout,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.limitLayout) = $event)),
                                            "track-by": "value",
                                            label: "text",
                                            placeholder: _ctx.selectPlaceholder,
                                            options: _ctx.limitLayouts,
                                            showLabels: false
                                        }, {
                                            noResult: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                                                    _createTextVNode("No results found", -1 /* CACHED */)
                                                ]))]),
                                            _: 1 /* STABLE */
                                        }, 8 /* PROPS */, ["modelValue", "placeholder", "options"])
                                    ])
                                ])
                            ];
                        }),
                        _: 1 /* STABLE */
                    })
                ]),
                _cache[31] || (_cache[31] = _createTextVNode()),
                _createElementVNode("div", _hoisted_20, [
                    (!_ctx.isNewAlarmType)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_AlarmDefinitionsVue, { alarmTypeId: _ctx.alarmTypeId }, null, 8 /* PROPS */, ["alarmTypeId"])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ])
        ])
    ], 512 /* NEED_PATCH */)), [
        [_vShow, _ctx.loaded]
    ]);
}
